<template>
  <InputField
    v-bind="$props"
    tag="textarea"
    :invalid-feedback="invalidFeedback ?? errorMessage"
    :value="value"
    @input="value = $event.target.value"
  >
  </InputField>
</template>

<script lang="ts">
export type TextFieldProps = Omit<InputFieldProps, "tag"> & {
  modelValue?: string | null;
  name?: string;
  required?: boolean;
};
</script>

<script lang="ts" setup>
import { uniqueId } from "underscore";
import { useField } from "vee-validate";
import InputField, { InputFieldProps } from "./InputField.vue";

const props = withDefaults(defineProps<TextFieldProps>(), {
  id: uniqueId("field-"),
});

const { value, errorMessage } = useField<string | null | undefined>(
  () => props.name ?? props.id,
  undefined,
  { syncVModel: true }
);
</script>
